import { render } from "./PVDataTable.vue?vue&type=template&id=11693a94"
import script from "./PVDataTable.vue?vue&type=script&lang=js"
export * from "./PVDataTable.vue?vue&type=script&lang=js"

import "./PVDataTable.vue?vue&type=style&index=0&id=11693a94&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__